import React from 'react'
import { routes } from '../../Utils'
import { Navigate, useNavigate } from 'react-router'
import { useDispatch, useSelector } from 'react-redux'
import { getSignUpState, setMobileNumberVerified } from '../../Store'
import { Content, SignUpPageStyled } from '../SignUpPage.styled'
import { incrementQuickCounter } from '@mobi/utils/logging/quickCounter'

export type MfaVerificationPage = ({
  accountNumber,
  onCompleted,
}: {
  accountNumber: number
  onCompleted: (skipped: boolean) => void
}) => React.JSX.Element

interface PhoneNumberValidationProps {
  MfaVerificationPage: React.MemoExoticComponent<MfaVerificationPage>
}

export const PhoneNumber = ({ MfaVerificationPage }: PhoneNumberValidationProps) => {
  const nextStep = routes.security
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const signupState = useSelector(getSignUpState)
  const accountNumber = signupState?.newUserBetAccount

  const onCompleted = (skipped: boolean) => {
    if (!skipped) {
      dispatch(setMobileNumberVerified())
    }
    incrementQuickCounter(`mfa-in-signup-phone-verifiy-${skipped ? 'skipped' : 'complete'}`)
    navigate(nextStep)
  }

  // Should always have account number at this stage
  if (!accountNumber) return <Navigate to={nextStep} />

  return (
    <SignUpPageStyled>
      <Content>
        <MfaVerificationPage accountNumber={accountNumber} onCompleted={onCompleted} />
      </Content>
    </SignUpPageStyled>
  )
}
